import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Input, Layout, message, Row, Space, Table} from "antd";
import SettingsSidebar from "./SettingsSidebar";
import {PATH} from "../../../config"; 
import axiosData from "../../../helpers/axiosData";
import NumberFormat from "react-number-format";
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";

import {fetchUser, login} from "../../../redux/features/userSlice";
import { setOpenPlotOnMap } from "../../../redux/actions/landActions";
import { Link } from "react-router-dom";


const {Content} = Layout;

const Claims = ({props}) => {



    const dispatch = useDispatch();
    let launchpadPlotLimit = useSelector ((state) => state.land.LaunchpadPlotLimit); 


    const fetchUserData = async (dispatch, getState) => {
        try {
            await dispatch(fetchUser())
        } catch (error) {
            console.log('fetchUser error', error)
        } 
    };


    let GetUser = useSelector((state) => state.user.user);

    const claimCryptoAsset = (id) => {

        axiosData
            .post('/api/_web3/user/claim-referral', {claim_id:id})
            .then((res) => {
                if (res && res.data.success) {
                    toast.success("Updated Successfully!");            
                    dispatch(fetchUserData)

                } else {
                    toast.error("Error Occured"); 
                }
            })
            .catch((error) => {
                toast.error("Error Occured"); 
                console.log('status error: ', error)
            }) 
    }

    const GetClaimableLands = (length_) => {
        let list = [];

        for (let i = 0; i < length_; i++) {
            
            list.push(<Col xs={24} sm={24} md={12} lg={6} className="mb-9">
                            <div className="w-100 thumb">
                                <div className="thumb-asset thumb-claim_asset" style={{background: `url(${PATH + 'land-claim.png'}) no-repeat center center / cover`}}>
                                </div>
                                <div className="flex flex-col items-center gap-y-3 thumb-claim thumb-claim_page">
                                    <Link to="/city"  onClick={()=>{dispatch(setOpenPlotOnMap(0, 3))}}>
                                        <Button className="border-0 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-normal gland-claim_btn">Claim</Button>
                                    </Link>
                                </div>
                            </div>
                        </Col>)
            
        }

        return list;
    } 
     

    useEffect(() => {
    }, [])


  

    return <div className="container mx-auto pt-162 min-h-calc-head h-full">
                <Layout className="h-full settings-layout">
                        <ToastContainer />
            <SettingsSidebar /> 
            <Content className="pt-8 pl-10 pr-4 settings-content">
                <h3 className="text-xl text-white font-bold mb-5 settings-title">Claims</h3>
                <p className="font-light mb-15">You have the potential to increase your earnings by inviting a greater number of individuals.</p>
                <Row gutter={36}>
                    
                    {launchpadPlotLimit!='-' && launchpadPlotLimit > 0 ? 
                        GetClaimableLands(launchpadPlotLimit)                        
                    :''}

                    {GetUser && GetUser.referral_claimable && GetUser.referral_claimable.length ?
                        GetUser.referral_claimable.map(li => {
                            return (                     
                            <Col xs={24} sm={24} md={12} lg={6} key={li.id} className="mb-9">
                                <div className="flex flex-col items-center claims-thumb">
                                    <img src={PATH + li.short.toLowerCase() + '_icon.svg'} className="mb-4 claims-thumb_icon" alt=""/>
                                    <span className="uppercase font-light claims-thumb_amount">{li.crypto_value}</span>
                                    <span className="uppercase font-bold claims-thumb_ctg" style={{color: "#45EAFF"}}>{li.short}</span>
                                    <Button onClick={()=>{claimCryptoAsset(li.id)}} className="border-0 mt-2 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-normal gland-claim_btn">Claim</Button>
                                </div>
                            </Col>
                            )
    
                        })
                    :''
                    }

                    {/* <Col xs={24} sm={24} md={12} lg={6} className="mb-9">
                        <div className="flex flex-col items-center claims-thumb">
                            <img src={PATH + `soto_icon.svg`} className="mb-4 claims-thumb_icon" alt=""/>
                            <span className="uppercase font-light claims-thumb_amount">1,650,000.56</span>
                            <span className="uppercase font-bold claims-thumb_ctg" style={{color: "#45EAFF"}}>SOTO</span>
                            <Button className="border-0 mt-2 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-normal gland-claim_btn">Claim</Button>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={6} className="mb-9">
                        <div className="flex flex-col items-center claims-thumb">
                            <img src={PATH + `meto_icon.svg`} className="mb-4 claims-thumb_icon" alt=""/>
                            <span className="uppercase font-light claims-thumb_amount">1,650,000.56</span>
                            <span className="uppercase font-bold claims-thumb_ctg" style={{color: "#CF4EF7"}}>METO</span>
                            <Button className="border-0 mt-2 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-normal gland-claim_btn">Claim</Button>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={6}>
                        <div className="flex flex-col items-center claims-thumb">
                            <img src={PATH + `bnb.svg`} className="mb-4 claims-thumb_icon" alt=""/>
                            <span className="uppercase font-light claims-thumb_amount">1,650,000.56</span>
                            <span className="uppercase font-bold claims-thumb_ctg" style={{color: "#EFB80A"}}>BUSD</span>
                            <Button className="border-0 mt-2 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-normal gland-claim_btn">Claim</Button>
                        </div>
                    </Col> */}
                    {/* <Col xs={24} sm={24} md={12} lg={6}>
                        <div className="flex flex-col items-center claims-thumb">
                            <img src={PATH + `badges/badge_member.svg`} className="mb-2 badge-icon" alt=""/>
                            <span className="uppercase font-normal claims-thumb_label">TEAM MEMBER</span>
                            <span className="uppercase font-bold claims-thumb_ctg">BADGE</span>
                            <Button className="border-0 mt-2 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-normal gland-claim_btn">Claim</Button>
                        </div>
                    </Col> */}
                </Row>
            </Content>
        </Layout>
    </div>
}

export default Claims;